import apolloClient from 'api/apolloClient';
import { GET_IMQS_ZIP } from 'api/queries/imqsService';

export async function getIMQsZip(groupId: string, entityId: string): Promise<string> {
  return (
    await apolloClient.mutate<{ getIMQsZip: string }>({
      mutation: GET_IMQS_ZIP,
      variables: { groupId, entityId },
      fetchPolicy: 'no-cache',
    })
  ).data!.getIMQsZip;
}
